import { render } from "./MyDomains.vue?vue&type=template&id=adedf29e&scoped=true"
import script from "./MyDomains.vue?vue&type=script&lang=ts"
export * from "./MyDomains.vue?vue&type=script&lang=ts"

import "./MyDomains.vue?vue&type=style&index=0&id=adedf29e&scoped=true&lang=scss"
import "./MyDomains.vue?vue&type=style&index=1&id=adedf29e&lang=scss"
script.render = render
script.__scopeId = "data-v-adedf29e"

export default script